module.exports = __webpack_public_path__ + "static/media/banner.f46fbd9f.png";